var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoNotificacao(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36 36",
    style: {
      enableBackground: "new 0 0 36 36"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M79.4,20.2h-1.5l-1.4-2.3c2.3-1.7,4.1-4.3,4.4-7c0.8-0.4,1.2-1.2,1.2-2.4V5.6c0-0.9-0.6-1.6-1.2-2.1V1.8 c1.3-1.9,1.2-4.1-0.4-5.7c-2.2-2.3-6.8-2.9-10.7-0.2c-5.1,0.1-7.4,1.8-7.4,5.5v2.3c-0.5,0.4-1.2,1.1-1.2,2.1v2.9 c0,1.1,0.3,1.8,0.8,2.2c0.3,2.7,2.1,5.5,4.4,7.2l-1.5,2.2h-1.4c-4.9,0-8,2.7-8,7.1V29c0,0.6,0.6,1.1,1.2,1.1c0.6,0,1.2-0.5,1.2-1.2 v-1.6c0-3.9,3-4.7,5.6-4.7h2.2c0.4,0,0.8-0.2,1-0.5l2-2.8c0.9,0.4,1.9,0.6,2.8,0.6c1,0,2.1-0.3,3.1-0.7l1.8,2.9 c0.2,0.4,0.6,0.6,1,0.6h2.2c1.4,0,6,0.3,6,4.7V29c0,0.7,0.5,1.2,1.2,1.2S88,29.7,88,29v-1.6C87.9,23,84.6,20.2,79.4,20.2z M64.5,10 c0-0.5-0.3-0.9-0.8-1.1c0-0.1,0-0.2,0-0.3V5.8c0.1-0.1,0.3-0.4,0.6-0.5c0.4-0.2,0.6-0.6,0.6-1V1.4c0-1.4,0-3.1,5.4-3.1 c0.3,0,0.5-0.1,0.7-0.2c3.2-2.4,6.6-1.6,7.9-0.3c0.8,0.9,0.8,1.9,0,2.9c-0.2,0.2-0.3,0.4-0.3,0.7v2.9c0,0.4,0.2,0.8,0.6,1 c0.2,0.1,0.5,0.4,0.5,0.4v2.9c0,0.1,0,0.2,0,0.2c-0.6,0.1-1.1,0.6-1.1,1.2c0,3.3-4,7.4-7.2,7.4C68.2,17.5,64.5,13.4,64.5,10z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "Shape_16_",
    d: "M18,35.5c-2.9,0-5.2-2.3-5.3-5.2c0,0,0,0,0,0H4c-1,0-1.8-0.8-1.8-1.8c0-0.2,0-0.4,0.1-0.6L4,23v-5 c-0.1-3.6,0.9-7.2,3-10.2c1.9-2.7,4.7-4.5,7.8-5.2c0.8-1.8,2.8-2.6,4.6-1.8c0.8,0.4,1.5,1,1.8,1.8c3.2,0.7,6,2.6,7.8,5.2 c2,3,3.1,6.5,3,10.2v5l1.6,4.7c0.5,0.8,0.2,1.9-0.7,2.4c-0.3,0.1-0.6,0.2-0.9,0.2h-8.8C23.2,33.2,20.9,35.5,18,35.5 C18,35.5,18,35.5,18,35.5z M18,5.7C11.6,5.7,7.5,10.6,7.5,18v5.3c0,0.2,0,0.4-0.1,0.6l-1,2.9h23.2l-1-2.9c-0.1-0.2-0.1-0.4-0.1-0.6 V18C28.5,10.6,24.4,5.7,18,5.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoNotificacao);
export default __webpack_public_path__ + "static/media/ico-notificacao.7512435e09570ef77e4e3e7080443929.svg";
export { ForwardRef as ReactComponent };